<div class="fdk-input">
  <label
    class="fdk-input__label"
    [class.fdk-input__label--visually-hidden]="hideLabel"
    [for]="inputId">
    {{ label }}
    @if (required) {
      <span
        class="fdk-input__required"
        aria-hidden="true">*</span>
    }
  </label>

  <input
    class="fdk-input__control"
    (blur)="handleBlur()"
    (input)="handleInput($event)"
    [class.fdk-input__control--error]="error"
    [attr.autocomplete]="autocomplete"
    [attr.aria-describedby]="describedBy"
    [attr.aria-invalid]="error ? 'true' : null"
    [attr.list]="list"
    [attr.maxlength]="maxlength"
    [attr.minlength]="minlength"
    [attr.name]="name"
    [disabled]="disabled"
    [id]="inputId"
    [placeholder]="placeholder"
    [required]="required"
    [value]="value"
    [type]="type" />

  @if (showErrorMessage) {
    <p
      class="fdk-input__error"
      [id]="errorMessageId">
      {{ errorMessage }}
    </p>
  }
</div>
